import { DEFAULT_HOSPITAL_CONFIG } from '../../../utils/config/defaultPortalHospitalConfig'

export default () => ({
  hospitalConfig: { ...DEFAULT_HOSPITAL_CONFIG },
  loadedFromApi: false,
})
